<template>
  <div class="w-full mb-6">
    <div class="w-full">
      <global-wrapper
        :loading="fileLoading"
        :empty="agenda.dokumen.length <= 0"
        loadingType="twoLine"
      >
        <global-file-upload
          v-for="(item, index) in agenda.dokumen"
          :key="index"
          :item="item"
        >
          <template slot="action">
            <vs-button
              color="primary"
              type="border"
              icon="icon-download"
              icon-pack="feather"
              size="small"
              class="mr-3"
              @click="downloadFile(item.file_url)"
              >Download</vs-button
            >
            <vs-button
              color="danger"
              type="border"
              icon="icon-trash"
              icon-pack="feather"
              size="small"
              @click="removeDocument(item.uuid)"
              >Hapus</vs-button
            >
          </template>
        </global-file-upload>
        <template #empty>
          <div class="w-full mb-2">Belum ada file laporan yang di upload</div>
        </template> </global-wrapper
      ><br />

      <input
        type="file"
        accept=".jpg,.jpeg,.png,.docx,.xlsx,.pdf"
        class="hidden"
        ref="uploadFile"
        @change="onChangeFileUpload($event)"
        name="upload-file"
      />
      <vs-button
        @click="uploadFile()"
        type="border"
        size="small"
        icon-pack="feather"
        icon="icon-upload"
        >Upload File</vs-button
      >
    </div>
    <LoadingDialog
      ref="loadingDialog"
      :progress="progress"
      @onAccept="submitCallback()"
      @onCancel="removeDocument(responseValue.uuid)"
    />
  </div>
</template>
<script>
import { digofHttp as axios } from "@/axios";
import LoadingDialog from "@/components/dialog/LoadingDialog";

export default {
  components: {
    LoadingDialog
  },
  props: {
    agenda: {
      type: Object
    }
  },
  data() {
    return {
      fileLoading: false,
      fileLaporan: [],
      progress: 0,
      responseValue: []
    };
  },
  computed: {
    listUserCanUpload() {
      let pesertaAgenda = this.agenda.peserta_agenda.map(item => {
        return parseInt(item.pengguna_id);
      });
      pesertaAgenda.includes(this.agenda.pengguna_id)
        ? ""
        : pesertaAgenda.push(parseInt(this.agenda.pengguna_id));
      return pesertaAgenda;
    }
  },
  methods: {
    uploadFile() {
      this.$refs.uploadFile.click();
    },
    onChangeFileUpload(event) {
      this.postDocument(event);
    },
    downloadFile(url) {
      window.open(url);
    },
    submitCallback() {
      this.$emit("submitCallback");
    },
    async postDocument(event) {
      var self = this;
      const formData = self.getFormDataPayload(event);
      self.$refs.loadingDialog.toggleActive(true);
      self.fileLoading = true;

      await axios({
        url: "upload/dokumen",
        method: "post",
        headers: {
          "Content-Type": "multipart/form-data"
        },
        data: formData,
        onUploadProgress(progressEvent) {
          self.progress = Math.round(
            (progressEvent.loaded * 100) / progressEvent.total
          );
        }
      })
        .then(response => {
          self.fileLoading = false;
          self.responseValue = response.data.data.data;
          // this.$emit("submitCallback");
        })
        .catch(error => {
          self.fileLoading = false;
          console.error(error);
          self.$vs.notify({
            title: "Pemberitahuan",
            text: `Gagal dalam upload laporan`,
            color: "danger",
            position: "top-right"
          });
        });
    },
    getFormDataPayload(event) {
      let formData = new FormData();
      let file = event.target.files[0];

      formData.append("dokumen_type", "App\\Models\\Agenda");
      formData.append("dokumen_id", this.agenda.id);
      formData.append("tipe", "agenda");
      formData.append("path", "agenda");
      formData.append("file", file);

      return formData;
    },
    async removeDocument(documentUuid) {
      this.fileLoading = true;

      await axios
        .delete(`/upload/hapus-dokumen/${documentUuid}`)
        .then(response => {
          this.$emit("submitCallback");
          this.$vs.notify({
            title: "Pemberitahuan",
            text: `Berhasil menghapus file`,
            color: "warning",
            position: "top-right"
          });
          this.fileLoading = false;
          return response.data;
        })
        .catch(error => {
          this.fileLoading = false;
          console.error(error);
          this.$vs.notify({
            title: "Pemberitahuan",
            text: `Gagal dalam menghapus file`,
            color: "danger",
            position: "top-right"
          });
        });
    }
  }
};
</script>
